var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ApplicationsApi, CredentialApi, FactorsApi, UserApi } from 'api/config/apiConfig';
import { mapToModelUser } from 'api/mapper/mapToModelUser';
export const getUserApplications = () => __awaiter(void 0, void 0, void 0, function* () {
    return ApplicationsApi.getUserApplications();
});
export const getUser = () => __awaiter(void 0, void 0, void 0, function* () {
    return UserApi.getUser();
});
export const getUserEnrolledFactors = () => __awaiter(void 0, void 0, void 0, function* () {
    return FactorsApi.getUserEnrolledFactors();
});
export const getUserAvailableFactors = () => __awaiter(void 0, void 0, void 0, function* () {
    return FactorsApi.getUserAvailableFactors();
});
export const updateUserProfile = (updatedProfile) => __awaiter(void 0, void 0, void 0, function* () {
    const request = mapToModelUser(updatedProfile);
    return UserApi.updateUserProfile(request);
});
export const updateUserPassword = (currentPassword, newPassword) => __awaiter(void 0, void 0, void 0, function* () {
    const request = { currentPassword, newPassword };
    return CredentialApi.updateUserPasswordCredential(request);
});
